<mg-email-input
    #emailInput="ngModel"
    [(ngModel)]="userEmailAddress"
    [altStyling]="true"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disabled || isSigningUp || isRequestingLogin || isLoading"
    [class._is_visible]="!userIsLoggedIn"
    [required]="!userIsLoggedIn"
    (keyup.enter)="doSubmit()"
></mg-email-input>

<mat-checkbox [(ngModel)]="isPrivacyPolicyAgreedTo">
    <ng-container i18n="@@privacy-policy.before-link">I agree to MisterGreen's </ng-container>
    <a
        target="_blank"
        href="https://mistergreen.nl/privacy-policy"
        i18n-href="@@privacy-policy.link-url"
        i18n="@@privacy-policy.link-text"
        >privacy policy</a
    >
    <ng-container i18n="@@privacy-policy.after-link">.</ng-container>
</mat-checkbox>

<div
    class="mat-input-error typography-headline-5 typography-text-white"
    *ngIf="emailExists && !userIsLoggedIn"
    i18n="@@configurator.general.email-is-known"
>
    The given e-mail address is already registered in our system. Please confirm this by logging in from your e-mail
    address.
</div>

<div class="buttons">
    <mg-ui-button
        identifier="analytics-login-button"
        type="button"
        [isGhost]="isGhost"
        [isLoading]="isLoading || isSigningUp"
        [disabled]="!isSubmitAllowed"
        (click)="doSubmit()"
        [class._is_to_right]="emailExists && !userIsLoggedIn"
    >
        <ng-content></ng-content>
    </mg-ui-button>
</div>
